import { Time } from "@angular/common";

export class CmsLoginMainContentProperties {
  sr: number = 0;
  title: string = "";
  image: string = "";
  description: string = "";
}
export class LoginUserProperties {
  loginName: string = "";
  password: string = "";
  agencyId: string = "";
  isAuthorized: boolean;
  mobile: string = "";
  email: string = "";
  otp: string;
  otpTimeout: Time;
  toAuthorize: string;
  success: boolean;
}
export class OTPLogin {
  digit1: string = "";
  digit2: string = "";
  digit3: string = "";
  digit4: string = "";
  digit5: string = "";
  digit6: string = "";
}
